<template>
  <div class="home">
    <NavBarTop @request-demo="openDemoModal" ref="navbar" />
    <HeroSection ref="hero" />
    <CircularLifecycleSection />
    <AboutUsSection />
    <ServicesSection />
    <ProductsSection />
    <FAQSection />
    <ContactSection />
    <FooterSection @request-demo="openDemoModal" />
  </div>
</template>

<script>
import NavBarTop from './Navbar.vue'
import HeroSection from './Hero.vue'
import ProductsSection from './Products.vue'
import AboutUsSection from './AboutUs.vue'
import ServicesSection from './Services.vue'
import CircularLifecycleSection from './CircularLifecycle.vue'
import FAQSection from './FAQ.vue'
import ContactSection from './Contact.vue'
import FooterSection from './Footer.vue'

export default {
  name: 'HomePage',
  components: {
    NavBarTop,
    HeroSection,
    ProductsSection,
    AboutUsSection,
    ServicesSection,
    CircularLifecycleSection,
    FAQSection,
    ContactSection,
    FooterSection
  },
  methods: {
    openDemoModal() {
      // Access the HeroSection component via ref and call its openDemoModal method
      if (this.$refs.hero) {
        this.$refs.hero.openDemoModal();
      }
    }
  }
}
</script>

<style scoped>
.home {
  min-height: 100vh;
}
</style> 